<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'Rule',
})
</script>
<template>
  <a-card title="内容组件">
    <template #extra>
      <a-button type="primary" @click="onAdd">新增</a-button>
    </template>
    <a-table :dataSource="dataSource" :pagination="page"
    :loading="loading" :columns="columns" @change="pageChange" >
    <template #bodyCell="{ column, record,index }">
      <template v-if="column.key === 'operation'">
        <a-button-group>
            <a-button v-if="pageRule.edit>0" size="small" type="primary" @click="onSet(record,index)">
                <EditOutlined /> 管理
            </a-button>
            <a-button v-if="pageRule.del>0" size="small" type="primary" @click="onDel(record,index)">
                <EditOutlined /> 删除
            </a-button>
          </a-button-group>
      </template>
    </template>
    </a-table>
    <sectionedit v-model:open="open" :data="model"  @change="submit">
    </sectionedit>
    <a-drawer
      v-model:open="opend" :destroyOnClose="true"
      title="组件内容"
      width="80%"
      placement="right"
    >
     <sectionSet :id="model.ID"></sectionSet>
  </a-drawer>
  </a-card>
</template>
<script setup lang="ts" name="Rule">
import api from '@/utils/http/service'
import {onMounted,defineProps,ref,watch,reactive,createVNode,defineComponent} from 'vue'
import { PlusOutlined,EditOutlined,DeleteOutlined } from '@ant-design/icons-vue'
import { useRoute } from 'vue-router'
import {DefaultRule} from '@/router/types'
import sectionedit from './pageset/sectionedit.vue'
import sectionSet from './pageset/sectionset.vue'
  onMounted(()=>{
    getList()
    if(useRoute().meta.rule){
      pageRule.value=useRoute().meta.rule
    }
  })
  const open=ref<boolean>(false)
  const opend=ref<boolean>(false)
  const model=ref<Object>({})
  const usertype=ref('')
  const pageRule=ref<any>(DefaultRule())
  const rules=ref<Object>({
    title:{name:'标题',required:true},
    sub:{name:'描述'},
    icon:{name:'图标',domtype:'img'},
    pic:{name:'图片',domtype:'img'},
    orders:{name:'排序',domtype:'number'},
    contents:{name:'内容',domtype:'editor'}
  })
  const columns=[
    {
      title: '名称',
      dataIndex: 'title',key:'title'
    },
    {
    title: '操作',
    key: 'operation',
    fixed: 'right',
    width: 100,
  },
  ]
  const page=ref<PageData>({
    current:1,
    pageSize:10,
    pageFlag:true,
    total:0,
    pageStatus:'more',
    currentKey: 'pageIndex',
    pageSizeKey: 'pageSize',
  })
  const loading=ref<boolean>(false)
  const dataSource=ref<Array<any>>([])
  const getList=():void=>{
    loading.value=true
      api.section.list({pageIndex:page.value.current,pageSize:page.value.pageSize}).then(res => {
        loading.value=false
        dataSource.value=res.data.data
        page.value.total=res.data.records
        page.value.current=res.data.pageIndex

      })
  }
  const pageChange=(e:anly)=>{
    page.value=e
    getList()
  }
  const onAdd=(item:any,i:any):void=>{
      var v={ID:0,title:'',sub:'',contents:'',pic:'',pid:item.ID,orders:1,icon:''}
      model.value=v
      open.value=true
  }
  const onDel=(item:any,i:any):void=>{
      api.section.del(item.ID).then(res=>{
        if(res.state==1){
          dataSource.value.splice(i,1)
        }
      })
  }
  const onEdit=(item:any,i:any):void=>{
    model.value=item
    open.value=true
  }
  const submit=(e:any)=>{
    api.section.add(e).then(res=>{
      if(res.state==1){
        dataSource.value.unshift(res.data)
        open.value=false
      }
    })
  }
const onSet=(item:any,i:any)=>{
  model.value=item
  opend.value=true
}
</script>
